import React from 'react';
//import {Route} from 'react-router-dom';
import {Container, Row} from 'react-bootstrap';
import Header from '../components/Header';

const PublicRoute = ({children}) => {

  return (
    <>
      <Header/>
      <Container fluid className="public-component-parent">
        <Row className="justify-content-center">
            {children}
        </Row>
      </Container>
    </>
  )
};
/*
const PublicRoute = ({component: Component, ...rest}) => {
  //console.log('in public route');

  return (
    <Route {...rest}>
      <>
        <Header/>
        <Container fluid className="public-component-parent">
          <Row className="justify-content-center">
            <div className="public-component">
              <Component/>
            </div>
          </Row>
        </Container>
      </>
    </Route>
  );

};
*/
export default PublicRoute;
